module.exports = __webpack_public_path__ + "static/media/Image.e9f2af90.svg";